//
export const ACCOUNT_MEMBER_SELECT_QUERY = 'ACCOUNT_MEMBER_SELECT_QUERY';
export const ACCOUNT_MEMBER_SELECT_QUERY_SET_PARAMS = 'ACCOUNT_MEMBER_SELECT_QUERY_SET_PARAMS';
export const ACCOUNT_MEMBER_SELECT_QUERY_RESET = 'ACCOUNT_MEMBER_SELECT_QUERY_RESET';
export const ACCOUNT_MEMBER_SELECT_QUERY_SUCCESS = 'ACCOUNT_MEMBER_SELECT_QUERY_SUCCESS';
export const ACCOUNT_MEMBER_SELECT_QUERY_FAIL = 'ACCOUNT_MEMBER_SELECT_QUERY_FAIL';